import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8ZM10.8228 10.2949C10.9552 9.99414 11.0215 9.65576 11.0215 9.27979C11.0215 8.90739 10.9552 8.57259 10.8228 8.27539C10.6903 7.97461 10.513 7.72038 10.291 7.5127C10.069 7.30143 9.8112 7.1403 9.51758 7.0293C9.22754 6.91829 8.92318 6.86279 8.60449 6.86279H7.19727L7.33691 5.5415H10.7046V4H5.95117L5.5 8.4043H8.60449C8.70833 8.4043 8.81217 8.42399 8.91602 8.46338C9.02344 8.49919 9.11833 8.55469 9.20068 8.62988C9.28662 8.7015 9.35466 8.79281 9.40479 8.90381C9.4585 9.01123 9.48535 9.13656 9.48535 9.27979C9.48535 9.43734 9.4585 9.57161 9.40479 9.68262C9.35466 9.79362 9.28662 9.88493 9.20068 9.95654C9.11833 10.0282 9.02344 10.0801 8.91602 10.1123C8.81217 10.1445 8.70833 10.1606 8.60449 10.1606H5.5V11.7021H8.60449C8.92318 11.7021 9.22754 11.6466 9.51758 11.5356C9.8112 11.4246 10.069 11.2653 10.291 11.0576C10.513 10.8499 10.6903 10.5957 10.8228 10.2949Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }